import { FeaturedList, Product } from "@/@types";
import { FeaturedListResponse, ProductResponse } from "../../promotion/models/FeaturedListResponse";

export function mapFeaturedList(response: FeaturedListResponse[]): FeaturedList[] {
    return response.map(featured => ({
        id: featured.id,
        name: featured.name,
        order: featured.order,
        productType: featured.product_type,
        products: featured.products?.map((product: ProductResponse): Product => ({
            name: product.name,
            shortName: product.short_name,
            longName: product.long_name,
            image: product.image,
            urlImage: product.url_image,
            slug: product.slug,
            order: product.order,
        })),
    }));
}